import CommitmentPage from './CommitmentPage';

export default CommitmentPage;
